"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[680],{

/***/ 20680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/analytics/index.ts + 4 modules
var analytics = __webpack_require__(30588);
// EXTERNAL MODULE: ./src/truck/alert/index.tsx + 1 modules
var truck_alert = __webpack_require__(7724);
// EXTERNAL MODULE: ./src/truck/anchor/index.ts
var truck_anchor = __webpack_require__(75689);
// EXTERNAL MODULE: ./src/truck/button/index.tsx + 2 modules
var truck_button = __webpack_require__(48721);
// EXTERNAL MODULE: ./src/truck/field/index.tsx + 2 modules
var field = __webpack_require__(49318);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var label = __webpack_require__(67734);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/components/social-login-buttons/index.js + 4 modules
var social_login_buttons = __webpack_require__(46924);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
;// CONCATENATED MODULE: ./src/components/login-form/elements.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > *:not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-2c806807-0"
})(_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c806807-1"
})(_templateObject1(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);

;// CONCATENATED MODULE: ./src/components/login-form/index.tsx

function login_form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  vertical-align: middle;\n"
    ]);
    login_form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(icon/* default */.Z).withConfig({
    componentId: "sc-be53c5b1-0"
})(login_form_templateObject());
var LoginForm = function(props) {
    var ref;
    var handleSubmit = props.handleSubmit, submitting = props.submitting, style = props.style, className = props.className, submitErrors = props.submitErrors;
    var hasPartnersFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.MULTI_VENDOR_NAVIGATION */.id.MULTI_VENDOR_NAVIGATION);
    var hasEnableCodeToLoginFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.ENABLE_CODE_TO_LOGIN */.id.ENABLE_CODE_TO_LOGIN);
    var preSignUpFeature = (0,toggled_esm/* useFeature */.SS)(constants/* flags.PRE_SIGN_UP */.id.PRE_SIGN_UP);
    var preSignUpURL = preSignUpFeature === null || preSignUpFeature === void 0 ? void 0 : (ref = preSignUpFeature.settings) === null || ref === void 0 ? void 0 : ref.url;
    var encodedURL = "/redirect?callback=" + encodeURIComponent(preSignUpURL);
    var redirectAnalytics = function() {
        return analytics/* analytics.preSignUpAttempt */.co.preSignUpAttempt();
    };
    var generalError = (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.credentials) || (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.rateLimit);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, {
        children: [
            generalError && /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_alert/* default */.Z, {
                type: "error",
                message: generalError
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                onSubmit: handleSubmit,
                style: style,
                className: className,
                children: [
                    hasEnableCodeToLoginFF ? /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                        name: "code",
                        placeholder: "C\xf3digo"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                        name: "email",
                        placeholder: "Correo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                        name: "password",
                        placeholder: "Contrase\xf1a",
                        type: "password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default */.Z, {
                        loading: submitting,
                        children: "Ingresar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(social_login_buttons/* default */.Z, {}),
                    !hasPartnersFF && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: "/recuperar-contrasena",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                            $color: "info",
                            $textStyle: "h6Regular",
                            children: "\xbfOlvidaste tu contrase\xf1a?"
                        })
                    }),
                    preSignUpURL && /*#__PURE__*/ (0,jsx_runtime.jsxs)(label/* default */.Z, {
                        as: "p",
                        $textStyle: "h6Regular",
                        children: [
                            "\xbfNo cuentas con acceso a la tienda?\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(truck_anchor/* default */.Z, {
                                target: "_blank",
                                href: encodedURL,
                                $color: "info",
                                onClick: redirectAnalytics,
                                $textStyle: "h6Regular",
                                children: [
                                    "Solic\xedtalo aqu\xed\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                                        color: "info",
                                        type: "launch",
                                        size: "sm"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var login_form = (LoginForm);


/***/ }),

/***/ 46924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ social_login_buttons; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-facebook-login/dist/facebook-login-render-props.js
var facebook_login_render_props = __webpack_require__(18228);
var facebook_login_render_props_default = /*#__PURE__*/__webpack_require__.n(facebook_login_render_props);
// EXTERNAL MODULE: ./node_modules/react-google-login/dist/google-login.js
var google_login = __webpack_require__(93645);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/@react-oauth/google/dist/index.esm.js
var index_esm = __webpack_require__(86426);
// EXTERNAL MODULE: ./src/analytics/index.ts + 4 modules
var analytics = __webpack_require__(30588);
// EXTERNAL MODULE: ./src/gql/mutations/index.ts + 42 modules
var mutations = __webpack_require__(36651);
// EXTERNAL MODULE: ./src/hooks/use-is-mobile.ts
var use_is_mobile = __webpack_require__(66345);
// EXTERNAL MODULE: ./src/hooks/use-vendor.ts
var use_vendor = __webpack_require__(1360);
// EXTERNAL MODULE: ./src/truck/notifier/index.tsx + 2 modules
var notifier = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./src/utils/after-auth.ts
var after_auth = __webpack_require__(36491);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
// EXTERNAL MODULE: ./src/truck/utils/index.ts + 8 modules
var truck_utils = __webpack_require__(14250);
;// CONCATENATED MODULE: ./src/components/social-login-button/elements.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  border: none;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  height: ",
        "px;\n  outline: none;\n  padding: 0 ",
        "px;\n  width: 100%;\n  ",
        "\n\n  > span {\n    flex-grow: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: white;\n  border-radius: 2px;\n  display: inline-flex;\n  height: 28px;\n  justify-content: center;\n  margin-left: 2px;\n  width: 28px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Button = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-dd5784e3-0"
})(_templateObject(), function(props) {
    return props.bgColor;
}, theme/* default.dimensions.borderRadius */.Z.dimensions.borderRadius, theme/* default.dimensions.buttonHeight */.Z.dimensions.buttonHeight, theme/* default.spacing.cozy */.Z.spacing.cozy, (0,truck_utils/* getTextStyle */.BN)("h5Semibold"));
var GoogleIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dd5784e3-1"
})(_templateObject1());

// EXTERNAL MODULE: ./src/utils/cloudinary.ts
var cloudinary = __webpack_require__(61761);
;// CONCATENATED MODULE: ./src/components/social-login-button/google-icon.js




var logoUrl = cloudinary/* default.getFullUrl */.Z.getFullUrl("v1563875361/sellers/g-icon.svg");
var GoogleIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleIconContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: "google",
            src: logoUrl
        })
    });
};
/* harmony default export */ var google_icon = (GoogleIcon);

;// CONCATENATED MODULE: ./src/components/social-login-button/index.js











var _obj;
var providerOptions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* loginProviders.FACEBOOK */.eH.FACEBOOK, {
    bgColor: "#4267b2",
    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
        size: "lg",
        type: "facebook"
    })
}), (0,_define_property/* default */.Z)(_obj, constants/* loginProviders.GOOGLE */.eH.GOOGLE, {
    bgColor: "#4285F4",
    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_icon, {})
}), _obj);
var SocialLoginButton = function(props) {
    var provider = props.provider, rest = (0,_object_without_properties/* default */.Z)(props, [
        "provider"
    ]);
    var options = providerOptions[provider];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        bgColor: options.bgColor,
        children: [
            options.icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Continuar con ".concat((0,lodash.capitalize)(provider))
            })
        ]
    }));
};
/* harmony default export */ var social_login_button = (SocialLoginButton);

;// CONCATENATED MODULE: ./src/components/social-login-buttons/elements.ts

function elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > *:not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-db5b22b0-0"
})(elements_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);

;// CONCATENATED MODULE: ./src/components/social-login-buttons/index.js


















var renderFacebookButton = function(props) {
    var onClick = props.onClick, isSdkLoaded = props.isSdkLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(social_login_button, {
        provider: constants/* loginProviders.FACEBOOK */.eH.FACEBOOK,
        onClick: onClick,
        disabled: !isSdkLoaded
    });
};
var GoogleLoginButton = function(param) {
    var onSocialLogin = param.onSocialLogin;
    var handleGoogleLogin = (0,index_esm/* useGoogleLogin */.Nq)({
        onSuccess: function(tokenResponse) {
            onSocialLogin(constants/* loginProviders.GOOGLE */.eH.GOOGLE, tokenResponse.code);
        },
        flow: "auth-code"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(social_login_button, {
        provider: constants/* loginProviders.GOOGLE */.eH.GOOGLE,
        onClick: handleGoogleLogin
    });
};
var SocialLoginButtons = function(props) {
    var style = props.style, className = props.className;
    var apolloClient = (0,react_hooks_esm/* useApolloClient */.xJ)();
    var vendor = (0,use_vendor/* default */.Z)();
    var isMobile = (0,use_is_mobile/* default */.Z)();
    var onSocialLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(provider, token) {
            var options, response, error, ref, ref1, message;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = {
                            mutation: mutations/* socialLoginMutation */.zW,
                            variables: {
                                provider: provider,
                                token: token
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            apolloClient.mutate(options)
                        ];
                    case 2:
                        response = _state.sent();
                        analytics/* analytics.login */.co.login(provider);
                        return [
                            4,
                            (0,utils/* sleep */._v)(constants/* timeouts.REDIRECTION */.I1.REDIRECTION)
                        ];
                    case 3:
                        _state.sent();
                        (0,after_auth/* saveSession */.A)(response.data.socialLogin);
                        (0,after_auth/* default */.Z)();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        message = error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.message;
                        if (message) {
                            notifier/* default.error */.Z.error(message, {
                                timeout: 5 * 1000
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSocialLogin(provider, token) {
            return _ref.apply(this, arguments);
        };
    }();
    var onFacebookLogin = function(data) {
        return onSocialLogin(constants/* loginProviders.FACEBOOK */.eH.FACEBOOK, data.accessToken);
    };
    if (!vendor.facebookAppId && !vendor.googleClientId) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        style: style,
        className: className,
        children: [
            vendor.facebookAppId && /*
         * We need to disabled redirect on mobile.
         *
         * There is an issue for this:
         * https://github.com/keppelen/react-facebook-login/issues/175
         *
         * `disableMobileRedirect` is an undocumented prop that solves it:
         * https://github.com/keppelen/react-facebook-login/issues/257
         * https://github.com/keppelen/react-facebook-login/pull/192
         */ /*#__PURE__*/ (0,jsx_runtime.jsx)((facebook_login_render_props_default()), {
                appId: vendor.facebookAppId,
                fields: "first_name,last_name,email",
                isMobile: isMobile,
                callback: onFacebookLogin,
                render: renderFacebookButton,
                disableMobileRedirect: true
            }),
            vendor.googleClientId && !vendor.googleClientSecret && /*#__PURE__*/ (0,jsx_runtime.jsx)(google_login.GoogleLogin, {
                clientId: vendor.googleClientId,
                cookiePolicy: "single_host_origin",
                onSuccess: function(data) {
                    return onSocialLogin(constants/* loginProviders.GOOGLE */.eH.GOOGLE, data.tokenId);
                },
                render: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(social_login_button, {
                        provider: constants/* loginProviders.GOOGLE */.eH.GOOGLE,
                        onClick: props.onClick,
                        disabled: props.disabled
                    });
                }
            }),
            vendor.googleClientId && vendor.googleClientSecret && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleLoginButton, {
                onSocialLogin: onSocialLogin
            })
        ]
    });
};
/* harmony default export */ var social_login_buttons = (SocialLoginButtons);


/***/ })

}]);